import { Dispatcher } from '@huggg/bar-staff';
import history from 'utilities/history';

class HistoryService {
  constructor() {
    if (HistoryService._instance) {
      return HistoryService._instance;
    }

    this._mapHistoryToClass();
    this._beforeBackCallback = null;
    this._beforeForwardCallback = null;
    this._beforePushCallback = null;
    this._nextPathname = null;
    this._stopListener = null;
    this._previousPathname = null;

    this.go = this.go.bind(this);
    this.goBack = this.goBack.bind(this);
    this.goForward = this.goForward.bind(this);
    this.push = this.push.bind(this);

    history.listen((data) => {
      this._previousPathname = this.location.pathname;
      this.location = { ...this.location, ...data };
    });

    this._Dispatcher = new Dispatcher();
    HistoryService._instance = this;
  }

  getPreviousPathname() {
    return this._previousPathname;
  }

  go(n) {
    const isNegative = parseInt(n, 10) < 0;

    if (isNegative) {
      this._Dispatcher.dispatch('beforeBack');
      this._Dispatcher.off('beforeBack', this._beforeBackCallback);
      this._beforeBackCallback = null;
    } else {
      this._Dispatcher.dispatch('beforeForward');
      this._Dispatcher.off('beforeForward', this._beforeForwardCallback);
      this._beforeForwardCallback = null;
    }

    history.go(n);
  }

  goBack() {
    this.go(-1);
  }

  goForward() {
    this.go(1);
  }

  onBeforeBack(callback) {
    if (!this._beforeBackCallback) {
      this._beforeBackCallback = callback;
      this._Dispatcher.on('beforeBack', this._beforeBackCallback);
    }
  }

  onBeforeForward(callback) {
    if (!this._beforeForwardCallback) {
      this._beforeForwardCallback = callback;
      this._Dispatcher.on('beforeForward', this._beforeForwardCallback);
    }
  }

  onBeforePush(callback) {
    if (!this._beforePushCallback) {
      this._beforePushCallback = callback;
      this._Dispatcher.on('beforePush', this._beforePushCallback);
    }
  }

  onChange(callback) {
    return history.listen(callback);
  }

  offChange(stopListener) {
    stopListener();
  }

  push(pathname, state) {
    if (!pathname) return;

    this._previousPathname = this.location.pathname;
    this._Dispatcher.dispatch('beforePush');
    this._Dispatcher.off('beforePush', this._beforePushCallback);
    this._beforePushCallback = null;

    history.push(pathname, state);
  }

  /**
   * Map the history node module to this class
   */
  _mapHistoryToClass() {
    Object.keys(history).forEach((key) => {
      if (!this[key]) {
        this[key] = history[key];

        if (this[key].constructor === Function) {
          this[key].bind(this);
        }
      }
    });
  }
}

export default HistoryService;
